/** @format */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
	selector: 'pdp-add-to-cart-component-fulfillment-button',
	templateUrl: './fulfillment-button.component.html',
	styleUrl: './fulfillment-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdpFulfillmentButtonComponent {
	readonly isSelected = input(false);
	readonly isDisabled = input(false);

	readonly buttonClicked = output<void>();
}
